"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _TypographyBase = _interopRequireDefault(require("../TypographyBase"));
var _responsiveProps = require("../utilities/responsiveProps");
var _Label = _interopRequireDefault(require("./Label.styles"));
const _excluded = ["component", "classes", "className", "noWrap", "size", "endIcon", "startIcon", "children"];
/**
 * **❗️ DEPRECATED**: Use the new `Label` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/typography-label):
 *
 * ```tsx
 * import { Label } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/horizon-web-ui-kit/?path=/docs/typography-label)
 *
 * @deprecated
 */
const Label = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      component = 'span',
      classes: classesOverrides,
      className,
      noWrap = false,
      size = 'md',
      endIcon: endIconProp,
      startIcon: startIconProp,
      children
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = (0, _Label.default)(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  const startIcon = startIconProp && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.startIcon
  }, startIconProp);
  const endIcon = endIconProp && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.endIcon
  }, endIconProp);
  const classNames = cx(classes.root, ...getSizeClassKey(size, classes), {
    [classes.noWrap]: noWrap,
    [classes.withIcon]: !!startIcon || !!endIcon
  }, className);
  return /*#__PURE__*/_react.default.createElement(_TypographyBase.default, (0, _extends2.default)({
    component: component,
    className: classNames,
    size: size,
    type: "label",
    ref: ref
  }, other), startIcon, children, endIcon);
});
function getSizeClassKey(size, classes) {
  return (0, _responsiveProps.getResponsiveClassNamesForProp)(size, 'size').map(className => classes[className]);
}
var _default = exports.default = Label;